import { useState } from 'react';
import { FormMode } from '@sib/utils';
import { DetailsModalView } from '@sidecar/common/components/DetailsModal';
import { TaskDetailsModalContent } from '@sidecar/common/components/TaskForm/TaskDetailsModal/TaskDetailsModalContent';

interface GlobalSearchTaskDetailsModalContentProps {
  taskId: string;
  onClose: () => void;
}

export const GlobalSearchTaskDetailsModalContent = ({
  taskId,
  onClose,
}: GlobalSearchTaskDetailsModalContentProps) => {
  const [view, setView] = useState(DetailsModalView.Details);

  return (
    <TaskDetailsModalContent
      onClose={onClose}
      taskId={taskId}
      type={FormMode.Edit}
      isEdit
      view={view}
      onViewChange={setView}
      navigationMode="local"
      showCompletedField
    />
  );
};
